import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import RichText from "@/components/RichText";
import useSEO, { stripHtml, injectJsonLd, removeJsonLd } from "@/lib/seo";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/faqs", { params: { only_active: true } }).then((r) => setFaqs(r.data || [])).finally(() => setLoading(false)); }, []);
  useSEO({
    title: "Häufige Fragen",
    description: "Antworten auf die häufigsten Fragen rund um das Quartier am Hornschen Tor in Detmold — Bauablauf, Verkehr, Lärm, Beteiligung und mehr.",
    path: "/faq",
  });
  useEffect(() => {
    if (!faqs || faqs.length === 0) return;
    injectJsonLd("faq-jsonld", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: stripHtml(f.answer, 800) },
      })),
    });
    return () => removeJsonLd("faq-jsonld");
  }, [faqs]);

  return (
    <div className="container-narrow py-16 lg:py-24 max-w-3xl" data-testid="faq-page">
      <p className="text-xs uppercase tracking-[0.18em] text-[hsl(var(--brand-green-strong))] mb-4">Fragen & Antworten</p>
      <h1 className="font-semibold text-4xl sm:text-5xl mb-6">Häufige Fragen</h1>
      <p className="text-neutral-600 mb-12">
        Hier finden Sie Antworten auf die wichtigsten Fragen rund um das Quartier am Hornschen Tor. Sollte Ihre Frage nicht beantwortet sein, melden Sie sich gerne bei der Stadt Detmold.
      </p>

      {loading ? (
        <p className="text-neutral-500 text-sm">Lade…</p>
      ) : faqs.length === 0 ? (
        <div className="border border-dashed border-brand-line p-12 text-center text-neutral-500">Noch keine Fragen veröffentlicht.</div>
      ) : (
        <Accordion type="single" collapsible className="bg-white border border-brand-line">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="px-6 border-b border-brand-line last:border-0">
              <AccordionTrigger data-testid={`faq-question-${f.id}`} className="text-left text-neutral-800 hover:no-underline py-5">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-600 leading-relaxed pb-5">
                <RichText html={f.answer} className="prose-quartier" />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </div>
  );
}
